import { skipToken } from "@reduxjs/toolkit/query";
import { useNavigate, useParams } from "react-router-dom";
import { PageNotFound } from "../../../404";
import { BlogBody } from "../../../../components/blog/portableText";
import { BackButton } from "../../../../components/buttons/backButton";
import { useGetBlogPostBySlugQuery } from "../../../../redux/features/blog/blog.api";
import { formatDate } from "../../../../utils/helpers";
import { urlForImage } from "../../../../utils/sanityClient";

export const BlogArticlePage = () => {
  const { blogSlug } = useParams<{ blogSlug: string }>();
  const navigate = useNavigate();

  const { data: post, isLoading } = useGetBlogPostBySlugQuery(
    blogSlug ?? skipToken,
  );

  if (isLoading) {
    return <div className="max-width-website py-20" />;
  }

  if (!post) {
    return (
      <div className="max-width-website py-10">
        <PageNotFound />
      </div>
    );
  }

  return (
    <div className="max-width-website flex flex-col items-center gap-[70px] pb-20 pt-12 md:pt-20">
      <div className="flex w-full max-w-[700px]">
        <BackButton
          text="Back to blog"
          onClick={() => navigate("/blog")}
          className="!p-0"
        />
      </div>

      <div className="flex w-full max-w-[700px] flex-col items-center gap-[70px]">
        <div className="flex w-full flex-col items-center gap-6 text-center">
          <p className="font-onest text-[16px] font-normal leading-[28px] tracking-[-0.32px] text-grey-800">
            {post.category?.title}
            {post.category?.title ? " ∙ " : ""}
            {formatDate(post.publishedAt, "MMM D, YYYY", true)}
          </p>

          <div className="flex flex-col items-center gap-3 text-center">
            <p className="font-dela text-[32px] leading-[34px] tracking-[-0.64px] text-ink md:text-[48px] md:leading-[50px] md:tracking-[-0.96px]">
              {post.title}
            </p>

            {post.excerpt ? (
              <p className="font-onest text-[20px] font-normal leading-[28px] tracking-[-0.4px] text-grey-800">
                {post.excerpt}
              </p>
            ) : undefined}
          </div>
        </div>

        {post.mainImage ? (
          <div className="aspect-[16/9] w-full overflow-hidden rounded-[8px]">
            <img
              src={urlForImage(post.mainImage)
                .width(1400)
                .height(788)
                .fit("crop")
                .url()}
              alt={post.mainImage.alt || post.title}
              className="h-full w-full object-cover"
            />
          </div>
        ) : undefined}

        <BlogBody value={post.body} />
      </div>
    </div>
  );
};
